import { put, takeEvery } from 'redux-saga/effects'
import { VALIDATE_RECAPTCHA_LOADING, VALIDATE_RECAPTCHA_SUCCESS, VALIDATE_RECAPTCHA_ERROR } from "../actions/actionRecaptcha";
import { apiValidateRecaptcha } from 'api';

async function fetchAsync(func, params) {
    const response = await func(params);

    if (response.ok && response.status == 200) {
        return true;
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    else if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Recaptcha : Suspicious activity detected. To make this purchase, please contact us directly.\"}]}")
    }
}

function* fetchValidateRecaptchaToken(action) {
    try {
        const data = yield fetchAsync(apiValidateRecaptcha, action.payload);
        if (data == "nocontent") throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Recaptcha : response was not fetched.\"}]}")
        else {
            yield put({ type: VALIDATE_RECAPTCHA_SUCCESS, payload: data });
        }
    } catch (e) {
        yield put({ type: VALIDATE_RECAPTCHA_ERROR, error: e });
    }
}

export const sagaRecaptcha = [
    takeEvery(VALIDATE_RECAPTCHA_LOADING, fetchValidateRecaptchaToken)
];
